import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const useRegisterHidden = (registration_end_date: string | undefined) => {
  if (!registration_end_date) return true;

  const deadline = dayjs.tz(`${registration_end_date} 23:59:59`, "Asia/Seoul");

  const now = dayjs().tz("Asia/Seoul");

  return now.isAfter(deadline); 
};
export default useRegisterHidden;